//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'underscore'
// import DIC from '@/index/dictonary'

export default {
  props: {
    options: {
      default: []
    },
    value: {
      default: ''
    },
    className: {
      default: ''
    },
    tabPosition: {
      default: 'left'
    }
  },
  data: function () {
    return {
      currentIndex: 0,
      currentValue: this.value
    }
  },
  watch: {
    value: {
      handler (val) {
        if (this.currentValue !== val) {
          this.currentValue = val
        }
      }
    },
    currentValue: {
      handler (val) {
        if (this.value !== val) {
          this.$emit('input', val)
        }
      }
    }
  },
  components: {

  },
  mounted () {

  },
  methods: {

  }
}
